/* v8 ignore start -- @preserve */
import { Skeleton } from "../shadcn/skeleton";

const NotificationPreferencesSkeletonItem = () => (
  <div className="flex w-full items-center gap-3 min-h-14">
    <div className="flex flex-col gap-2 flex-1">
      <Skeleton className="h-7 w-[30%]" />
      <Skeleton className="h-2 w-[50%]" />
    </div>
    <div className="ml-auto mr-3">
      <Skeleton className="h-12 w-20 rounded-full" />
    </div>
  </div>
);

export const NotificationPreferencesSkeleton = () => (
  <div
    className="flex w-full flex-col gap-4"
    data-testid="notification-preferences-skeleton"
  >
    <NotificationPreferencesSkeletonItem />
    <NotificationPreferencesSkeletonItem />
    <NotificationPreferencesSkeletonItem />
    <NotificationPreferencesSkeletonItem />
  </div>
);
